import React, { useEffect, useState } from "react";
import Tagadd from "../../components/Tag/tag-add/Tagadd";
import { Link } from "react-router-dom";
import "./banner.scss";
import Table from "react-bootstrap/Table";
import axios from "axios";
import AutoComplete from "rsuite/AutoComplete";
import ReactPaginate from "react-paginate";
import ModalUmum from "../../modal/modalUmum/ModalUmum";
import { BsSearch } from "react-icons/bs";
import dateFormat from "dateformat";

function Banner() {
  const [data, setData] = useState([]);
  const [autoComplete, setAutoComplete] = useState([]);
  const [search, setsearch] = useState(false);
  const [deleteSuccess, setDeleteSuccess] = useState();
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [getSuccess, setGetSuccess] = useState(false);
  const [itemsPerPage, setitemsPerPage] = useState(10);
  const [modalShow, setModalShow] = useState(false);
  const [idBanner, setIdBanner] = useState();

  const getData = async () => {
    const result = await axios.get("https://mobile.amospa.com/banners");
    const name = result.data.data.map((value) => value.name);
    setAutoComplete(name);
    setData(result.data.data);
    setGetSuccess(true);
  };

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  useEffect(() => {
    getData();
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [deleteSuccess, itemOffset, itemsPerPage, getSuccess]);

  //Handle search
  const keys = ["name"];
  const handleSearch = () => {
    return search
      ? data.filter((item) => keys.some((key) => item[key].includes(search)))
      : false;
  };

  const banner = handleSearch();
  const dataTable = banner ? banner : currentItems;

  //Handle Delete
  const deleteBanner = async (id) => {
    setIdBanner(id);
    setModalShow(true);
  };

  //Handle Next
  const handleNext = async () => {
    const result = await axios.delete(
      `https://mobile.amospa.com/banners/${idBanner}`
    );
    setDeleteSuccess(result);
    setModalShow(false);
    window.location.reload();
  };

  return (
    <div className="banner">
      <div className="banner-search-header py-4">
        <span className="d-flex align-items-center">
          <h3 className="mx-2 text-white">List Banner's</h3>
          <p>
            <select onChange={(e) => setitemsPerPage(e.target.value)}>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </p>
        </span>
        <span className="d-flex">
          <Link to={"/homepage/setting/banner/addbanner"}>
            <button
              className="btn rounded-3 me-2 fw-bold"
              style={{ background: "#FFD700" }}
            >
              ADD BANNER
            </button>
          </Link>
          <span className="d-flex align-items-center list-search bg-light rounded-3 ps-1 me-2">
            <BsSearch color="black" fontSize="20px" />
            <AutoComplete
              placeholder="Search . . ."
              id="rs-input"
              onChange={(e) => setsearch(e)}
              data={autoComplete}
            />
          </span>
        </span>
      </div>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>NO</th>
            <th>Name</th>
            <th>Notes</th>
            <th>Banner</th>
            <th>Created Date</th>
            <th>Options</th>
          </tr>
        </thead>
        <tbody>
          {dataTable.map((item, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{item ? item.name : ""}</td>
              <td>{item ? item.note : ""}</td>
              <td>
                <img src={item ? item.image : ""} alt="" />
              </td>
              <td>{dateFormat(new Date(item.createdAt), "d-mmmm-yyyy")}</td>
              <td className="d-flex">
                <Link
                  to={`/homepage/setting/banner/editbanner/${item.name}/${item.id}`}
                >
                  <button
                    className="btn-staffid ms-2 text-dark py-1 px-3"
                    style={{ borderRadius: "10px", background: "#FFD700" }}
                  >
                    Edit
                  </button>
                </Link>
                <button
                  className="btn-staffid ms-2 bg-danger px-2 py-1"
                  style={{ borderRadius: "10px" }}
                  onClick={() => deleteBanner(item.id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <div className="footer-banner mb-3">
        <p className="ms-2">
          Showing {currentItems.length} to {data.length} Entries
        </p>
        <div>
          <ReactPaginate
            breakLabel="..."
            nextLabel="next >"
            onPageChange={handlePageClick}
            pageRangeDisplayed={3}
            pageCount={pageCount}
            previousLabel="< previous"
            renderOnZeroPageCount={null}
            containerClassName="pagination"
            pageLinkClassName="page-num"
            previousLinkClassName="page-num"
            nextLinkClassName="page-num"
            activeLinkClassName="active"
          />
        </div>
      </div>
      <ModalUmum
        show={modalShow}
        onHide={() => setModalShow(false)}
        title="Delete Banner ?"
        nextButton={handleNext}
      />
    </div>
  );
}

export default Banner;
